import React, { Component } from "react";
import Hero from "./Hero.js";
import axios from "axios";
import _ from "lodash";
import { Link } from "react-router-dom";
import LogoBar from "./LogoBar";
import Related from "./Related";

import { renderMarkup } from "../utils.js";
class Products extends Component {
  constructor() {
    super();
    this.state = {
      data: [],
      services: null
    };
  }
  componentDidMount() {
    const SITE_URL = "https://oncourse.dev-ggmm.com";

    axios.get(SITE_URL + "/wp-json/wp/v2/pages?slug=products").then(res => {
      this.setState(
        {
          data: res.data[0].acf,
          services: res.data[0].acf.services
        },
        () => window.scrollTo(0, 0)
      );
    });
  }

  renderProductSections() {
    const { data } = this.state;
    return _.map(data.product_section, section => {
      if (section.layout_type === "left-simple") {
        return (
          <div className="left-simple">
            <div className="left">
              <img src={section.media} alt="Left Container" />
            </div>
            <div className="right">
              <div
                dangerouslySetInnerHTML={renderMarkup(section.main_content)}
              />
              <div className="btn-group">
                <Link to={section.main_link_url} className="btn main">
                  {section.main_link_title}
                </Link>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={section.secondary_link_url}
                  className="btn otl">
                  {section.secondary_link_title}
                </a>
              </div>
            </div>
          </div>
        );
      } else if (section.layout_type === "right-complex") {
        return (
          <div>
            {" "}
            <div className="right-complex">
              <div className="left">
                <div className="video-wrapper">
                  <iframe
                    title="Youtube"
                    width="560"
                    height="315"
                    src={"https://www.youtube.com/embed/" + section.video_url}
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
              </div>
              <div className="right">
                <div
                  dangerouslySetInnerHTML={renderMarkup(section.main_content)}
                />
                <div className="btn-group">
                  <Link to={section.main_link_url} className="btn main">
                    {section.main_link_title}
                  </Link>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={section.secondary_link_url}
                    className="btn otl">
                    {section.secondary_link_title}
                  </a>
                </div>
              </div>
            </div>
            <div className="three-col">
              {_.map(section.secondary_content_blocks, block => {
                return (
                  <div
                    className="col"
                    dangerouslySetInnerHTML={renderMarkup(block.content)}
                  />
                );
              })}
            </div>
          </div>
        );
      } else if (section.layout_type === "left-complex") {
        return (
          <div>
            <div className="left-complex">
              <div className="left">
                <div
                  dangerouslySetInnerHTML={renderMarkup(section.main_content)}
                />
                <div className="btn-group">
                  <Link to={section.main_link_url} className="btn main">
                    {section.main_link_title}
                  </Link>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={section.secondary_link_url}
                    className="btn otl">
                    {section.secondary_link_title}
                  </a>
                </div>
              </div>
              <div className="right">
 {section.media_type[0] === 'Video' && (
                  <div className="video-wrapper">
                  <iframe
                    title="youtube"
                    width="560"
                    height="315"
                    src={"https://www.youtube.com/embed/" + section.video_url}
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
 )}

 {section.media_type[0] === 'Image' && (
   <img src={section.media} alt="Product Section" />
 )}
              </div>
            </div>
            <div className="three-col">
              {_.map(section.secondary_content_blocks, block => {
                return (
                  <div
                    className="col"
                    dangerouslySetInnerHTML={renderMarkup(block.content)}
                  />
                );
              })}
            </div>
          </div>
        );
      }
    });
  }

  render() {
    const { data } = this.state;
    return (
      <div className="products">
        <Hero
          content={data.content_hero}
          linkTitle={data.link_title_hero}
          linkUrl={data.link_url_hero}
          image={data.background_image_hero}
          data={data}
        />
        <div className="inner wrapper max-width">
          {this.renderProductSections()}
        </div>
        <LogoBar page="Products" />
        <Related />
      </div>
    );
  }
}

export default Products;



// WEBPACK FOOTER //
// ./src/components/Products.js